import React from "react";
import ValidatedInput from "../../../commonComponents/util/ValidatedInput";
import Modal from "../../../commonComponents/util/Modal";
import FadeOutErrorMessage from '../../../commonComponents/util/FadeOutErrorMessage';
import { formatDateForInput, toTitleCase } from "../../../../lib/utils";

export default class EditReconciliationInfoModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitAttempted: false,
      report: props.report || {},
    };
  }

  onChange = (name, value) => {
    this.setState({ report: { ...this.state.report, [name]: value } });
  };

  continue() {
    if (!this.state.submitAttempted) this.setState({ submitAttempted: true });
    const report = this.state.report;
    if (
      report.reportName &&
      report.dateTo
    ) {
      this.props.continue(report);
    }
  }

  render() {
    // const { show } = this.props;
    const { submitAttempted, report } = this.state;
    return (
      <Modal modalShowing={true}>
        <div className="modal-container">
          <div className="modal new-transaction-modal large-modal">
            <div className="bordered-modal-header">
              <div>
                <h4 className="page-header">Edit Report Name and Date</h4>
              </div>
              <i className="icon ion-ios-close-empty" onClick={this.props.close} />
            </div>

            <div className="modal-section">
              <ValidatedInput
                input={<input type="text" />}
                required={true}
                showRequiredError={submitAttempted}
                value={report.reportName}
                onChange={(name, value) => this.onChange(name, toTitleCase(value))}
                name="reportName"
                label="Report Name"
              />
            </div>

            <div className="modal-section">
              <div className="column-half">
                <ValidatedInput
                  input={<input type="date" min={formatDateForInput(report.dateFrom)} max="9999-12-31"/>}
                  value={formatDateForInput(report.dateTo.length > 10 ? report.dateTo : new Date(report.dateTo + " 00:00:0000"))}
                  name="dateTo"
                  onChange={this.onChange}
                  required={true}
                  showRequiredError={submitAttempted}
                  label="To - Enter Bank Statement Date"
                />
              </div>

              <FadeOutErrorMessage show={this.props.invalidReportDate} message={'You have selected a date range that excludes a transaction that is marked as reconciled. \n Please uncheck transaction before altering the date range'}/>
            </div>

            <div className="modal-btns text-right">
              <button className="btn btn-accent" onClick={this.props.close}>
                Cancel
          </button>
              <button
                className="btn btn-primary"
                onClick={this.continue.bind(this)}>
                Continue
          </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/NewBankReconciliation/EditReconciliationInfoModal.jsx